function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRadioChecked = function SvgRadioChecked(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 132.29166 132.29167",
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "translate(0,-164.70832)",
    id: "layer1"
  }, React.createElement("path", {
    id: "path4487",
    transform: "matrix(0.26458333,0,0,0.26458333,0,164.70832)",
    d: "M 250,0 A 250.00001,250.00001 0 0 0 0,250 250.00001,250.00001 0 0 0 250,500 250.00001,250.00001 0 0 0 500,250 250.00001,250.00001 0 0 0 250,0 Z m 0,92.322266 A 157.67858,157.67858 0 0 1 407.67773,250 157.67858,157.67858 0 0 1 250,407.67773 157.67858,157.67858 0 0 1 92.322266,250 157.67858,157.67858 0 0 1 250,92.322266 Z",
    style: {
      opacity: 1,
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 25.73529434,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRadioChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/radio-checked.fe861bf1.svg";
export { ForwardRef as ReactComponent };